<template>
  <el-popover placement="left" width="690" trigger="click" popper-class="more_popover" v-model="visible">
    <div>
      <div class="more_popover_top">
        <div class="mb-16">
          <el-autocomplete popper-class="my-autocomplete" v-model="state" value-key="label" :fetch-suggestions="querySearch" placeholder="请输入内容" size="mini" @select="searchHandle">
            <el-button slot="append" size="mini" class="search-btn" icon="el-icon-search">查询</el-button>
            <template slot-scope="{ item }">
              <textOverflow>
                <span class="name" v-html="setSelectText(item)"></span>
              </textOverflow>
            </template>
          </el-autocomplete>
        </div>
        <div class="more_popover_content" :style="{height:isArea?'414px':'370px'}">
          <div class="hierarchy" ref="menus">
            <template v-for="(panel,i) in menus">
              <SubPanel :key="i" :data="panel" :activePath="activePath" :level="i" class="sub-pane" :style="i == menus.length-1? 'flex: 1 1 0%;': 'flex: 0 1 0%;'" @selected="clickSelect"
                @selectedAll="clearSub" />
            </template>
          </div>
        </div>
        <div class="div-selected">
          <p>已选（<span>{{selectedList.length}}</span>/{{maxSelected}}）<span style="cursor: pointer;" class="ml-10" @click="clearAll">清空</span></p>
          <div>
            <span v-for="(item,i) in selectedList" :key="i" @click="deleteTag(i)">
              {{item.parent? item.parent.label+'-'+ item.label:item.label}}
              <i class="el-icon-close"></i></span>
          </div>
        </div>
      </div>
      <div class="more_popover_bottom">
        <el-button size="small" type="text" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" @click="submitHandle">确定</el-button>
      </div>
    </div>
    <span slot="reference" :class="['showMore',{'is-opened':visible}]">{{popoverText}}
      <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
    </span>
  </el-popover>
</template>

<script>
import SubPanel from './subPanel.vue'
import multiLvSelect from '@/components/multiLvSelect/multiLvSelect.js'
export default {
  name: 'MultiLvSelectArea',
  extends: multiLvSelect,
  components: {
    SubPanel,
  },
  props: {
    props: Object,
    isArea: {
      type: Boolean,
      default: true
    },
    popoverText: {
      type: String,
      default: '更多'
    },
    data: {
      type: Array,
      default: () => []
    },
    echoList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      visible: false,
      selectedList: [],
      menus: [],
      activePath: [],
      nodes: null,
      restaurants: [],
      state: ''
    }
  }
}
</script>


<style lang="scss" scoped>
.more_popover {
  font-size: 12px;
  padding: 0;
  .more_popover_top {
    padding-bottom: 0;
    .div-selected {
      p {
        font-weight: 500;
        font-size: 12px;
        color: #000;
        height: 40px;
        line-height: 40px;
        span {
          color: #4f7afd;
        }
      }
      div {
        width: 100%;
        height: 73px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        span {
          display: inline-block;
          padding: 0 26px 0 8px;
          background: #f5f8ff;
          border-radius: 2px;
          font-size: 12px;
          color: #333;
          height: 22px;
          line-height: 22px;
          margin: 0 8px 8px 0;
          position: relative;
          cursor: pointer;
          &:hover {
            i {
              color: #4f7afd;
            }
          }
          i {
            position: absolute;
            right: 5px;
            top: 5px;
            font-size: 12px;
            color: #b2b7c2;
          }
        }
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #bbbeca;
        }
      }
    }
    .more_popover_content {
      height: 414px;
      border: 1px solid #eee;
      border-radius: 8px;
      .hierarchy {
        display: flex;
        height: 100%;
      }
      // .hierarchy3 {
      //   padding-top: 12px;
      //   padding-left: 28px;
      //   margin-right: -10px;
      //   display: flex;
      //   flex-wrap: wrap;
      //   align-content: flex-start;
      //   > div {
      //     line-height: 36px;
      //     margin-right: 30px;
      //     cursor: pointer;
      //     &:hover {
      //       color: #4f7afd;
      //     }
      //   }
      // }
      ::v-deep .sub-pane {
        overflow-y: auto;
        min-width: 129px;
        padding-top: 12px;
        border-right: 1px solid #f2f3f5;
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #bbbeca;
        }
        .hierarchy-name {
          &:hover {
            background: #ebf0fe;
          }
          padding: 8px 16px;
          cursor: pointer;
          &.is-select {
            color: #4f7afd;
            font-weight: 500;
            background: #ebf0fe;
          }
        }

        &:nth-child(4) {
          padding-top: 12px;
          border-right: none;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          > div {
            background: #fff !important;
            cursor: pointer;
            &:hover {
              color: #4f7afd !important;
            }
            &.is-select {
              color: #4f7afd;
              font-weight: 500;
              background: #fff;
            }
          }
        }
      }

      .is-select {
        color: #4f7afd;
        font-weight: 500;
      }
      .area-select {
        background: #f9f9f9;
        border-radius: 8px 8px 0 0;
        padding: 12px 0 11px 16px;
        .area-select-index {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.65);
          display: inline-block;
          background: #fff;
          border-radius: 4px;
          width: 21px;
          height: 21px;
          line-height: 21px;
          text-align: center;
          margin-right: 14px;
          cursor: pointer;
        }
      }
    }
    // .el-row {
    //   height: 32px;
    //   line-height: 32px;
    //   .el-col-12 + .el-col-12 {
    //     text-align: right;
    //     span {
    //       cursor: pointer;
    //     }
    //     span + span {
    //       margin-left: 15px;
    //     }
    //   }
    .search-btn {
      color: #fff;
      background: #4f7afd;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    // }
  }
  .more_popover_bottom {
    border-top: 1px solid #ededed;
    padding: 22px 32px;
    padding-top: 17px;
    text-align: right;
  }
}

.is-select1 {
  color: #4f7afd;
}

.showMore {
  cursor: pointer;
  font-size: 13px;
  color: rgba(51, 51, 51, 0.5);
  float: right;
  position: relative;
  width: 42px;
  i {
    color: rgba(52, 57, 81, 0.5);
    right: 0;
  }

  &.is-opened .el-submenu__icon-arrow {
    transform: rotate(180deg);
  }
}
</style>
